import {
  Badge,
  BodyText,
  DetailText,
  Flex,
  Heading,
} from '@utilitywarehouse/hearth-react';

import { formatCurrency } from '@utils/format';

import type { EarningsMilestone, Milestone } from './constants';

interface MilestoneTileProps {
  badge: 'Monthly' | 'Yearly';
  badgeColorScheme: 'cashback' | 'pig';
  amount: number;
  milestone: Milestone;
}

const MilestoneTile = ({
  badge,
  badgeColorScheme,
  amount,
  milestone,
}: MilestoneTileProps) => {
  return (
    <Flex
      direction="column"
      flex="1"
      alignItems="center"
      gap="300"
      width="100%"
    >
      <Flex direction="column" alignItems="center" gap="100">
        <Badge
          colorScheme={badgeColorScheme}
          variant={badgeColorScheme === 'cashback' ? 'emphasis' : 'subtle'}
          size="md"
        >
          {badge}
        </Badge>
        <DetailText size="2xl" data-tabular-nums>
          {formatCurrency({ value: amount })}
        </DetailText>
      </Flex>

      <img
        src={milestone.image}
        alt=""
        className="earnings-milestones-slide__image"
      />

      <Flex direction="column" gap="100" alignItems="center" textAlign="center">
        <Heading as="h4" size="md">
          {milestone.title}
        </Heading>
        <BodyText>{milestone.desc}</BodyText>
      </Flex>
    </Flex>
  );
};

interface EarningsMilestoneSlideProps {
  milestone: EarningsMilestone;
}

const EarningsMilestoneSlide = ({ milestone }: EarningsMilestoneSlideProps) => {
  const yearlyCashback = milestone.monthlyAmount * 12;

  return (
    <Flex
      direction={{ mobile: 'column', tablet: 'row' }}
      gap={{ mobile: '600', tablet: '400' }}
      width="100%"
      alignItems="start"
      className="earnings-milestones-slide"
    >
      <MilestoneTile
        badge="Monthly"
        badgeColorScheme="cashback"
        amount={milestone.monthlyAmount}
        milestone={milestone.monthly}
      />
      <MilestoneTile
        badge="Yearly"
        badgeColorScheme="pig"
        amount={yearlyCashback}
        milestone={milestone.yearly}
      />
    </Flex>
  );
};

export { EarningsMilestoneSlide };
